import React from 'react';
import './style.css';

function EmptyMessage(props) {
    return (
        <div className="Indicator-msg">
            <p>{props.empty_message}</p>
        </div>
    );
}

export default EmptyMessage
